import React, { FC } from 'react';
import { FormControl, InputLabel, Select } from '@material-ui/core';
import data_priority from '../../data/priority';

interface Props {
  value?: number;
  error?: boolean;
  required?: boolean;
  helperText?: string;
  className?: any;
  size?: 'small' | 'medium';
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
  fullWidth?: boolean;
}

const PrioritySelect: FC<Props> = React.forwardRef<any, Props>(
  ({ value, onChange, className, helperText, required, ...props }, ref) => {
    return (
      <FormControl
        ref={ref}
        className={className}
        variant='outlined'
        style={{ background: 'white' }}
        error={props.error}
        required={required}
        {...props}
      >
        <InputLabel>Priorité</InputLabel>
        <Select native label='Priorité *' value={value} onChange={onChange}>
          <option value='' />
          {Object.entries(data_priority).map(([key, data]: [string, any]) => (
            <option key={key} value={key}>
              {data.fr}
            </option>
          ))}
        </Select>
      </FormControl>
    );
  }
);

export default PrioritySelect;
